<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
  <div class="row w-100 justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8">
      <div class="card learn-more-card shadow-lg border-0">
        <div class="card-body p-0">
          <!-- Hero Image Section -->
          <div class="learn-more-hero position-relative">
            <img
              src="assets/Intercessory-Prayer-Training.jpg"
              alt="{{ 'LEARN_MORE.IMAGE_ALT' | translate }}"
              class="img-fluid w-100 hero-image"
            />
            <div class="hero-overlay d-flex align-items-center justify-content-center">
              <div class="text-center text-white">
                <div class="learn-more-icon mb-3">
                  <i class="fa fa-book fa-4x text-white"></i>
                </div>
                <h1 class="display-5 fw-bold mb-2">{{ 'LEARN_MORE.TITLE' | translate }}</h1>
                <p class="lead mb-0">{{ 'LEARN_MORE.SUBTITLE' | translate }}</p>
              </div>
            </div>
          </div>

          <!-- Content Section -->
          <div class="p-4 p-md-5">
            <!-- Introduction -->
            <div class="mb-5">
              <div class="row align-items-center">
                <!-- <div class="col-md-2 text-center mb-3 mb-md-0">
                  <div class="feature-icon">
                    <i class="fa fa-lightbulb-o fa-3x text-primary"></i>
                  </div>
                </div> -->
                <!-- <div class="col-md-10"> -->
                <div class="col-12 col-xl-10 mx-auto">
                  <p class="lead text-muted mb-0">
                    <b>{{ 'LEARN_MORE.INTRO_TEXT' | translate }}</b>
                  </p>
                </div>
              </div>
            </div>
            <!-- Topics Section -->
            <div class="mb-5">
              <div class="row">
                <!-- <div class="col-md-2 text-center mb-3 mb-md-0">
                  <div class="feature-icon">
                    <i class="fa fa-list-ul fa-3x text-success"></i>
                  </div>
                </div>
                <div class="col-md-10"> -->
                <div class="col-12 col-xl-10 mx-auto">
                  <!-- <h3 class="h4 mb-3 text-primary">Topics Title</h3> -->
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <div class="topic-item d-flex align-items-start">
                        <i class="fa fa-check-circle text-success me-3 mt-1"></i>
                        <span>{{ 'LEARN_MORE.TOPIC_1' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="topic-item d-flex align-items-start">
                        <i class="fa fa-check-circle text-success me-3 mt-1"></i>
                        <span>{{ 'LEARN_MORE.TOPIC_2' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="topic-item d-flex align-items-start">
                        <i class="fa fa-check-circle text-success me-3 mt-1"></i>
                        <span>{{ 'LEARN_MORE.TOPIC_3' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-6 mb-3">
                      <div class="topic-item d-flex align-items-start">
                        <i class="fa fa-check-circle text-success me-3 mt-1"></i>
                        <span>{{ 'LEARN_MORE.TOPIC_4' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Service Section -->
            <div class="mb-5">
              <div class="row align-items-center">
                <!-- <div class="col-md-2 text-center mb-3 mb-md-0">
                  <div class="feature-icon">
                    <i class="fa fa-heart fa-3x text-danger"></i>
                  </div>
                </div>
                <div class="col-md-10"> -->
                <div class="col-12 col-xl-10 mx-auto">
                  <h3 class="h4 mb-3 text-primary">{{ 'LEARN_MORE.SERVICE_TITLE' | translate }}</h3>
                  <p class="text-muted mb-0">
                    {{ 'LEARN_MORE.SERVICE_PARAGRAPH' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Treasure Section -->
            <div class="mb-4">
              <div class="row align-items-center">
                <!-- <div class="col-md-2 text-center mb-3 mb-md-0">
                  <div class="feature-icon">
                    <i class="fa fa-gem fa-3x text-warning"></i>
                  </div>
                </div>
                <div class="col-md-10"> -->
                <div class="col-12 col-xl-10 mx-auto">
                  <!-- <h3 class="h4 mb-3 text-primary">Treasure Title</h3> -->
                  <p class="text-muted mb-0">
                    {{ 'LEARN_MORE.TREASURE_PARAGRAPH' | translate }}
                  </p>
                </div>
              </div>
            </div>

            <!-- Call to Action -->
            <div class="text-center pt-4 border-top">
              <div class="row">
                <div class="col-12 col-md-6 mb-2 mb-md-0">
                  <a [routerLink]="['/register']" class="btn btn-primary btn-lg w-100">
                    <i class="fa fa-user-plus me-2"></i>{{ 'LEARN_MORE.GET_STARTED' | translate }}
                  </a>
                </div>
                <div class="col-12 col-md-6">
                  <a [routerLink]="['/contact-us']" class="btn btn-outline-info btn-lg w-100">
                    <i class="fa fa-question-circle me-2"></i>{{ 'LEARN_MORE.HAVE_QUESTIONS' | translate }}
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
